import React from 'react';

function Error404() {
  return (
    <div>
404
    </div>
  );
}

export default Error404;



// WEBPACK FOOTER //
// ./src/app/screens/Errors/404/index.js